/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import {
  Dialog,
  Box,
  useTheme,
  useMediaQuery,
  Button,
  TextField,
  Typography,
} from '@material-ui/core';
import { OnlyNumbersMask } from 'react-masked-text/src/masks/only-numbers.mask';
import { useSnackbar } from 'notistack';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MapsModal from '../MapsModal';
import api from '../../services/api';
import useStyles from './styles';

const StyledToggleButtonGroup = withStyles(theme => ({
  root: {
    marginTop: 10,
  },
  grouped: {
    border: '1px solid #eee',
    '&:not(:first-child)': {
      marginLeft: theme.spacing(4),
      borderLeftWidth: '1px',
      borderLeftColor: '#eee',
    },
    '&:first-child': {
      width: '120px',
    },
  },
}))(ToggleButtonGroup);

const StyledToggleButton = withStyles(() => ({
  selected: {
    borderColor: '#999',
  },
  root: {
    fontSize: 12,
  },
}))(ToggleButton);

export default function ConfirmAddressCreated({ setMarkerCoordinates }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const { token, loading } = useSelector(state => state.data);
  const { createAddressBasedOnMap, createdAddressBasedOnMap } = useSelector(
    state => state.adresses
  );

  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [reference, setReference] = useState('');
  const [name, setName] = React.useState('');
  const [newAddress, setNewAddress] = useState({
    name: '',
    zip_code: '',
    public_place: '',
    number: '',
    complement: '',
    state: '',
    code_state: '',
    city: '',
    code_city: '',
    neighborhood: '',
    phone: '',
    comments: '',
    latitude: '',
    longitude: '',
  });

  const handleFavPlace = (event, newName) => {
    setName(newName);
  };

  const handleConfirm = useCallback(async () => {
    const onlyNumbers = new OnlyNumbersMask();

    const zip_code = onlyNumbers.getRawValue(newAddress.zip_code.trim());
    if (zip_code.length <= 7) {
      enqueueSnackbar('Erro ao consultar seu CEP', {
        variant: 'error',
      });

      return;
    }

    if (loading) return;

    dispatch({ type: '@data/LOADING' });

    let data = {};

    if (newAddress.complement === '') {
      data = {
        ...newAddress,
        name:
          name.length === 0 && newAddress.name.length === 0
            ? newAddress.public_place
            : name,
        zip_code,
        complement: `${reference}`,
      };
    } else {
      data = {
        ...newAddress,
        name:
          name.length === 0 && newAddress.name.length === 0
            ? newAddress.public_place
            : name,
        zip_code,
        complement: `${newAddress.complement} - ${reference}`,
      };
    }

    try {
      const service = api(token);
      const res = await service.addressset(data);

      if (res && res.success) {
        dispatch({
          type: '@adresses/CREATE_SUCCESS',
          address: res.data,
        });

        dispatch({ type: '@data/LOADING' });
        return;
      }

      if (res && res.error) {
        dispatch({ type: '@data/LOADING' });
        enqueueSnackbar(res.error_message, { variant: 'error' });
        return;
      }

      dispatch({ type: '@data/LOADING' });
      enqueueSnackbar(
        'Houve uma falha interna e não foi possível salvar os dados. Tente mais tarde',
        { variant: 'error' }
      );
    } catch (error) {
      dispatch({ type: '@data/LOADING' });
      enqueueSnackbar(
        'Falha ao tentar enviar os dados. Verifique sua conexão com a internet',
        { variant: 'error' }
      );
    }
  }, [newAddress, name, reference]);

  const handleClose = useCallback(() => {
    dispatch({ type: '@adresses/CANCEL_ADDRESS_CREATE' });
    dispatch({
      type: '@adresses/SET_MARKER_COORD',
      markerCoordinates: null,
    });
  }, []);

  useEffect(() => {
    async function get(value) {
      const url = `https://viacep.com.br/ws/${value}/json/`;

      const data = await fetch(url).then(res => {
        return res.json();
      });

      if (data.erro) return;

      const { ibge: code_city } = data;

      setNewAddress(prev => ({
        ...prev,
        code_state: code_city.substr(0, 2),
        code_city,
      }));
    }

    if (createdAddressBasedOnMap.zip_code !== '') {
      get(createdAddressBasedOnMap.zip_code);
    }
  }, [createdAddressBasedOnMap.zip_code]);

  useEffect(() => {
    setNewAddress({
      name: '',
      zip_code: createdAddressBasedOnMap.zip_code,
      public_place: createdAddressBasedOnMap.public_place,
      number: createdAddressBasedOnMap.number,
      complement: '',
      state: createdAddressBasedOnMap.state,
      code_state: '',
      city: createdAddressBasedOnMap.city,
      code_city: '',
      neighborhood: createdAddressBasedOnMap.neighborhood,
      phone: '',
      comments: createdAddressBasedOnMap.comments,
      latitude: createdAddressBasedOnMap.latitude,
      longitude: createdAddressBasedOnMap.longitude,
    });
  }, []);

  const MapsModalToConfirm = useMemo(
    () => (
      <MapsModal
        coordinates={{ lat: newAddress.latitude, lng: newAddress.longitude }}
        setMarkerCoordinates={setMarkerCoordinates}
      />
    ),
    [newAddress.latitude, newAddress.longitude]
  );

  if (createAddressBasedOnMap) {
    return (
      <Dialog
        scroll="body"
        draggable="false"
        open={createAddressBasedOnMap}
        onClose={handleClose}
        fullScreen={fullScreen}
        aria-labelledby="form-dialog-title"
      >
        {MapsModalToConfirm}
        <Box
          style={{
            position: 'absolute',
            width: '100%',
            height: '60px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            top: 0,
            left: 0,
          }}
        >
          <IconButton onClick={handleClose} style={{ color: '#FF9000' }}>
            <ArrowBackIosIcon />
          </IconButton>
        </Box>
        <DialogTitle id="form-dialog-title">
          {createdAddressBasedOnMap.public_place},{' '}
          {createdAddressBasedOnMap.number}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText>
            {createdAddressBasedOnMap.neighborhood},{' '}
            {createdAddressBasedOnMap.city}, {createdAddressBasedOnMap.state}
          </DialogContentText>
          <Box className={classes.inputGroup}>
            <TextField
              id="standard-basic"
              defaultValue={createdAddressBasedOnMap.number}
              label="Número"
              className={classes.inputNumber}
              onChange={event => {
                setNewAddress({
                  ...newAddress,
                  number: event.target.value.substr(0, 100),
                });
              }}
            />
            <TextField
              id="standard-helperText"
              label="Complemento"
              helperText="Apto/Bloco/Casa"
              value={newAddress.complement}
              onChange={event => {
                setNewAddress({
                  ...newAddress,
                  complement: event.target.value.substr(0, 100),
                });
              }}
            />
          </Box>
          {createdAddressBasedOnMap.zip_code === '' ? (
            <TextField
              id="standard-helperText"
              label="CEP"
              helperText="Somente números"
              type="number"
              fullWidth
              value={newAddress.zip_code}
              onChange={event => {
                setNewAddress({
                  ...newAddress,
                  zip_code: event.target.value.substr(0, 100),
                });
              }}
            />
          ) : null}
          <TextField
            id="standard-helperText"
            label="Ponto de referência"
            helperText="Ex: Em frente á praça"
            fullWidth
            value={reference}
            onChange={event => {
              setReference(event.target.value.substr(0, 100));
            }}
          />
          <Typography style={{ marginTop: 20 }}>Favoritar como:</Typography>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 10,
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <StyledToggleButtonGroup
              value={name}
              exclusive
              onChange={handleFavPlace}
              aria-label="Favorite place"
            >
              <StyledToggleButton value="Casa" aria-label="home">
                <HomeOutlinedIcon />

                <Typography style={{ fontSize: 12, marginLeft: 5 }}>
                  Casa
                </Typography>
              </StyledToggleButton>
              <StyledToggleButton value="Trabalho" aria-label="work">
                <WorkOutlineOutlinedIcon />
                <Typography style={{ fontSize: 12, marginLeft: 5 }}>
                  Trabalho
                </Typography>
              </StyledToggleButton>
            </StyledToggleButtonGroup>
          </Box>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            className={classes.buttonConfirmAddress}
            variant="contained"
            color="primary"
            onClick={handleConfirm}
          >
            salvar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
